import faqMexico from './faq-mexico';
import faqChile from './faq-chile';

const faqByCountry = {
  Chile: faqChile,
  Mexico: faqMexico,
};

export default faqByCountry;
